import React from 'react'
import styled, { keyframes } from 'styled-components'

const makeItRain = keyframes`
  from {
    opacity: 1;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  to {
    top:90%;
  }
`

const ConfettiContainer = styled.div`
  height: 100%;
  position: relative;
  margin: 0rem auto 1rem auto;
  max-width:35rem;
  overflow:hidden;
`
const ConfettiPiece = styled.div`
  position: absolute;
  width: 8px;
  height: 16px;
  background: #db133a;
  top: 0;
  pointer-events: none;
  user-select: none;
  opacity: 0;
  animation: ${makeItRain} 1000ms infinite ease-out;
  transform: rotate(${(props) => props.rotateValue}deg);
  left: ${(props) => props.position}%;
  animation-delay: ${(props) => props.delay}ms;
  animation-duration: ${(props) => props.duration}ms;
  z-index:1;

  :nth-child(odd) {
    background: #ffd300;
  }
  :nth-child(4n) {
    width: 5px;
    height: 12px;
    animation-duration: 2000ms;
  }
  :nth-child(4n-7) {
    background: #068ae2;
  }
`

const rotate = [
  -40, -79, -51, 61, -52, 38, 11, 49, -72, 10, 21, 42, -72, 50, 19, -23, -17,
  13, 58, 63,
]
const position = [
  7, 14, 21, 28, 35, 42, 49, 56, 53, 70, 77, 84, 91, 42, 72, 32, 19, 23, 54, 65,
]
const delay = [
  252, 61, 50, 334, 22, 180, 107, 14, 149, 351, 107, 464, 312, 650, 188, 481,
  332, 187, 250, 150,
]
const duration = [
  2116, 1976, 3103, 2778, 2277, 2168, 1900, 887, 1179, 3059, 1332, 776, 1250, 1051,
  1100, 1200, 1895, 2500, 2220, 1170,
]
const Confetti = ({
  particleCount,
  rotateArr = rotate,
  positionArr = position,
  delayArr = delay,
  durationArr = duration,
  children,
  display=true
}) => {
  const confettiPieceArr = []

  for (let i = 0; i < particleCount; i++) {
    const confettiObj = {
      id: i,
      rotate: rotateArr[i],
      position: positionArr[i],
      delay: delayArr[i],
      duration: durationArr[i],
    }
    confettiPieceArr.push(confettiObj)
  }

  if (!display) return children

  return (
    <ConfettiContainer>
      {confettiPieceArr.map((piece) => (
        <ConfettiPiece
          key={piece.id}
          rotateValue={piece.rotate}
          delay={piece.delay}
          position={piece.position}
          duration={piece.duration}
        />
      ))}
      {children}
    </ConfettiContainer>
  )
}

export default Confetti
